import { render, staticRenderFns } from "./banner_pc.vue?vue&type=template&id=758b74a0&scoped=true"
import script from "./banner_pc.vue?vue&type=script&lang=js"
export * from "./banner_pc.vue?vue&type=script&lang=js"
import style0 from "./banner_pc.vue?vue&type=style&index=0&id=758b74a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758b74a0",
  null
  
)

export default component.exports